export const PRICING_CONFIG = {
  pro: {
    USD: {
      monthly: 5,
      '10m': 4.5,
      billed10m: 45
    },
    INR: {
      monthly: 99,
      '10m': 89,
      billed10m: 890
    }
  },
  premium: {
    USD: {
      monthly: 10,
      '10m': 9,
      billed10m: 90
    },
    INR: {
      monthly: 199,
      '10m': 179,
      billed10m: 1790
    }
  }
} as const;
